module.exports = __webpack_public_path__ + "static/What-s-the-difference-between-UI-and-UX-b50e5ef30b3c04557288e56e2d0c2334.png";